<template>
  <div :class="{ policyListContent: true, 'bg-white': empty }">
    <app-loading :loaded="loaded"></app-loading>
    <div class="search-wrap" v-if="(policyData && policyData.length) || status != '1'">
      <van-search
        v-model="searchValue"
        placeholder="请输入企业名称或保单号"
        show-action
        @search="search"
        input-align="left"
        clear-trigger="always"
      >
      <template #action>
        <div @click="search">搜索</div>
      </template>
      </van-search>
    </div>
    <van-sticky :offset-top="stickyTop" v-if="(policyData && policyData.length) || status != '1'">
      <van-tabs
        class="policyType"
        v-model="status"
        :swipe-threshold="3"
        @click="changeStatus"
      >
        <van-tab
          v-for="(item, i) in listNum"
          :key="i"
          :title="item.title + '(' + item.data.length + ')'"
          :name="item.typeCode"
        ></van-tab>
      </van-tabs>
    </van-sticky>
   
    <!-- 保障中无数据的情况 -->
    <div class="nodata" v-if="status == 1 && (!list || !list.length)">
      <div class="nodata-content">
        <div class="nodata-top">
          <img src="@static/images/group/empty.png" alt="" />
          <div class="top-desc">
            未找到您的团险保单，如您已经购买，请 联系您的专属客服绑定您的保单
          </div>
        </div>
      </div>
    </div>

    <div v-else class="list">
      <template v-if="list && list.length">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getPolicyData"
        >
          <div class="item" v-for="(item, i) in list" :key="i">
            <div class="topcontent" @click="actionDetail(item)">
              <div class="title">
                <span class="titleName">{{ item.insuranceName }}</span>
              </div>
              <div class="content">
                <div class="left">
                  <div class="lefti">
                    <span class="lefti-title">保单号：</span
                    ><span class="lefti-desc">{{ item.policyNo }}</span>
                  </div>
                  <!-- <div class="lefti" v-if="item.holderName">
                    <span class="lefti-title">投保人：</span
                    ><span class="lefti-desc">{{ item.holderName }}</span>
                  </div> -->
                  <div class="lefti" v-if="item.enterName">
                    <span class="lefti-title">投保企业：</span
                    ><span class="lefti-desc">{{ item.enterName }}</span>
                  </div>
                  <div class="lefti" v-if="item.insuranceTime">
                    <span class="lefti-title">保险期间：</span
                    ><span class="lefti-desc">{{ item.insuranceTime }}</span>
                  </div>
                  <div class="lefti active">保费：{{ item.amount || 0 }}元</div>
                </div>
                <div class="right">
                  <!-- 终保 -->
                  <img
                    v-if="item.policyCode == -2"
                    src="@static/images/group/zb.png"
                    alt=""
                  />
                  <div v-else-if="item.policyCode == 2" class="bzDay">
                    <span class="top">已保障</span>
                    <span class="bottom">{{ item.guaranteeDays || 0 }}天</span>
                  </div>
                  <!-- 退保 -->
                  <img
                    v-else-if="item.policyCode == -3"
                    src="@static/images/group/tb.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="btns" v-if="item.policyCode == 2">
              <span class="lp" @click="sqlpAnt(item)">申请理赔</span>
              <span class="pj" v-if="!item.comment" @click="evaluateAnt(item)"
                >评价产品</span
              >
            </div>
          </div>
        </van-list>
      </template>
      <template v-else>
        <div class="nodata-content">
          <div class="nodata-top">
            <img src="@static/images/group/empty.png" alt="" />
            <div class="top-desc">
              暂无保单
            </div>
          </div>
        </div>
      </template>
    </div>
    <one-settle :isEttle="isEttle" @isEttlement="isEttle = false"></one-settle>
  </div>
</template>
<script>
//当前实例组件
import common from "@/api/common.js"; //全局变量
import loading from "@/components/commons/loading";
import wxOpen from "@/components/wxOpen";
import { Toast } from "vant";
import oneSettle from "@/components/commons/oneSettle";
var vm, myChart;
export default {
  data: () => ({
    isEttle: false, //一键理赔
    status: "2", //保单状态
    loaded: true, //加载状态
    policyData: [], //保单总数据
    // list: null, //当前状态保单数据
    listNum: [
      {
        typeCode: "2",
        title: "保障中",
        data: [],
      },
      {
        typeCode: "-3",
        title: "已退保",
        data: [],
      },
      {
        typeCode: "-2",
        title: "已终保",
        data: [],
      },
    ], //数据统计相关
    analyse: null, //全部tab栏统计数据
    loading: false,
    finished: false,
    echartsIndex: "0",

    iscreated: false,
    wxtemplate: "<button style='width:100%;height:100%;opacity:0;'>1</button>",

    isWeixin: false, //是否显示小程序跳转按钮
    isApp: false,
    stickyTop: 0,
    showMore: true, //查看更多/收起
    searchValue: '', //搜索字段
  }),
  components: {
    "one-settle": oneSettle,
    "app-loading": loading,
    wxOpen: wxOpen,
  },
  computed: {
    list() {
      let item = this.listNum.find((i) => i.typeCode == this.status);
      if (item?.data?.length > 0) {
        return item.data;
      } else {
        return [];
      }
    },
    empty() {
      return this.list.length == 0 || this.policyData.length == 0;
    },
  },
  created() {
    vm = this;
    vm.iscreated = true;
    vm.status = this.$route.query.status ? Number(this.$route.query.status) : 1;
    console.log("created");
    var shareParam = {
      title: "保单列表",
      desc: "保单列表",
    };
    this.$weixin.share(shareParam);
    if (!this.$units.isLogin(this)) return;
    vm.loaded = false;
    //app或者微信环境下显示跳转小程序按钮
    vm.isWeixin = vm.$tools.isWeiXin();
    vm.isApp = vm.$tools.isWtsNativeApp();
    this.getPolicyData(() => {
      //获取所有保单
      vm.screenPolicy(); //进行保单数量筛选,tab显示报单数量
      setTimeout(() => {
        vm.loaded = true;
      }, 1500);
    });
  },
  activated() {
    vm = this;
    if (vm.iscreated) {
      return;
    }
    var shareParam = {
      title: "团险保单列表",
      desc: "团险保单列表",
    };
    this.$weixin.share(shareParam);
    //app或者微信环境下显示跳转小程序按钮
    vm.isWeixin = vm.$tools.isWeiXin();
    vm.isApp = vm.$tools.isWtsNativeApp();
    if (!this.$units.isLogin(this)) return;
    vm.loaded = false;
    this.getPolicyData(() => {
      vm.screenPolicy();
      setTimeout(() => {
        vm.loaded = true;
      }, 1500);
    });
  },
  deactivated() {
    vm.iscreated = false;
  },
  mounted() {
    //行为上传
    this.$units.reportUp(this.$config.user, 32, null, "访问团险保单管家");
  },
  methods: {
    //搜索
    search() {
      this.getPolicyData(() => {
        vm.screenPolicy();
        setTimeout(() => {
          vm.loaded = true;
        }, 1500);
      });
    },
    //获取保单数据
    getPolicyData(callback) {
      if (myChart) {
        myChart.clear();
        myChart = null;
      }
      var url = "/policy/V5/api/group/list";
      var params = {
        status: "",
        searchText: this.searchValue,
      };
      vm.$http({
        url: url,
        data: params,
      })
        .then((res) => {
          // vm.policyData = [
          //   {
          //     insuranceName: "测试",
          //     policyNo: "1312312312",
          //     holderName: "2",
          //     enterName: "3",
          //     insuranceTime: "4",
          //     amount: "5",
          //     policyCode: "2",
          //   },
          //   {
          //     insuranceName: "测试",
          //     policyNo: "1312312312",
          //     holderName: "2",
          //     enterName: "3",
          //     insuranceTime: "4",
          //     amount: "5",
          //     policyCode: "2",
          //   },
          // ];
          vm.policyData = res.data || [];
          if (callback) callback();
        })
        .catch((err) => {});
    },
    //保单状态筛选
    screenPolicy() {
      vm.loading = true;
      vm.finished = false;
      var listNum = JSON.parse(JSON.stringify(vm.listNum)); //深复制一层
      vm.listNum = listNum.map((item) => {
        return {
          ...item,
          data: vm.policyData.filter((i) => i.policyCode == item.typeCode),
        };
      });
      console.log("listNum-----------", vm.listNum);
      vm.loading = false;
      vm.finished = true;
      vm.$nextTick(() => {
        document.documentElement.scrollTop = 0;
      });
    },

    //保单状态切换
    changeStatus(name) {
      vm.status = name;
      vm.screenPolicy();
    },
    //产品评价
    evaluateAnt(item) {
      this.$router.push({
        path: "/m/personal/evaluateGroupPolicy/" + item.policyId,
        query: {
          isGroup: true,
          policyNo: item.policyNo,
        },
      });
    },

    //申请理赔
    sqlpAnt(item) {
      this.isEttle = true;
      //行为上传
      this.$units.reportUp(this.$config.user, 33, null, "访问一键理赔");
    },

    //查看详情
    actionDetail(item) {
      if (item.policyNo == 0) return this.$notice.msg("保单正在生成中！");
      var WTS_TOKEN_A = vm.$config.token;
      let url =
        common.env == 1
          ? `https://partner.txb99.com/app.html#/policyDetail?policyNo=${item.policyNo}&WTS_TOKEN_A=${WTS_TOKEN_A}`
          : `https://partner-ep.wts9999.net/app.html#/policyDetail?policyNo=${item.policyNo}&WTS_TOKEN_A=${WTS_TOKEN_A}`;
      location.href = url;
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-white {
  background-color: #fff;
}
.policyListContent {
  min-height: 100vh;
}
// @import "@/sass/personal/policyMyList";
/deep/.van-tabs__nav--line {
  height: 100px;
  line-height: 100px;
  margin-bottom: 20px;
  /deep/.van-tab {
    font-size: 28px;
    color: #3c464f;
    line-height: 40px;
  }
}
/deep/.van-tab--active {
  color: #377aff;
}
/deep/.van-tabs__line {
  display: none;
}
.van-sticky {
  background-color: #fff;
}
.content {
  position: unset;
}
.list {
  margin-top: 20px;
  padding: 0 20px;
  .item {
    padding: 34px 30px 0;
    background-color: #fff;
    position: relative;
    font-size: 28px;
    color: #3c464f;
    line-height: 34px;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    .title {
      font-size: 32px;
      font-weight: 600;
      line-height: 48px;
      margin-bottom: 20px;
    }
    .lefti {
      margin-bottom: 20px;
    }
    .active {
      font-weight: 600;
      color: #ff8700;
      font-size: 30px;
      line-height: 34px;
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid rgba($color: #979797, $alpha: 0.1);
    }
    .left {
      position: unset !important;
      width: 76%;
      word-break: break-all;
    }
    .right {
      top: 80px !important ;
      img {
        width: 130px;
        position: absolute;
        top: 100px;
        right: 30px;
      }
    }
  }
}
.bzDay {
  top: 80px;
  position: absolute;
  right: 30px;
  margin-top: 20px !important;
  width: 120px;
  height: 100px;
  border: 1px solid #ff8700;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 600;
  color: #ff8700;
  overflow: hidden;
  color: #ff8700;
  line-height: 50px;
  text-align: center;
  .top {
    display: block;
    color: #fff;
    height: 50px;
    background: #ff8700;
  }
}
.btns {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 30px;
  span {
    display: inline-block;
    width: 170px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 28px;
    margin-left: 20px;
    border-radius: 28px;
  }
  .lp {
    color: #8a9095;
    border: 1px solid #8a9095;
  }
  .pj {
    color: #236dff;
    border: 1px solid #236dff;
  }
}
.nodata {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}
// .nodata-content {
//   min-height: calc(100vh - 90px);
//   background-color: #fff;
//   margin: -20px;
// }
.nodata-top {
  text-align: center;
  img {
    margin-top: 224px;
    margin-bottom: 40px;
    width: 191px;
    height: 184px;
    background: #4a68cc;
  }
  .top-desc {
    width: 504px;
    font-size: 28px;
    color: #000000;
    line-height: 40px;
    margin: 0 auto;
  }
}
.search-wrap {
  display: flex;
  align-items: center;
  background-color: #fff;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  width: 100%;
  height: 88px;
  overflow: hidden;
  z-index: 2;
  .van-search {
    margin: 0 30px;
    padding: 0;
    flex: 1;
  }
  /deep/.van-field__clear {
    color: #727b8d;
  }
  .van-search__action {
    padding-right: 0;
    padding-left: 30px;
    font-size: 28px;
    color: #515a6e;
  }
  .van-search__content {
    width: 100%;
    height: 66px;
    background: #f3f3f3;
    border-radius: 8px;
  }
  /deep/.van-field__left-icon {
    display: flex;
    align-items: center;
    margin-right: 20px;
    img {
      width: 23.9px;
      height: 23.3px;
    }
  }
  .van-search--show-action {
    flex: 1;
  }
  /deep/.van-field__control {
    &::placeholder {
      font-size: 26px;
      color: #8a9095;
      font-weight: 400;
    }
  }
  /deep/.van-field__body {
    height: 100%;
  }
}
</style>
